import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "inner"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  key: 0,
  class: "row tags"
};
const _hoisted_4 = {
  class: "row author"
};
const _hoisted_5 = {
  class: "nickname"
};
const _hoisted_6 = ["data-clipboard-text"];
const _hoisted_7 = {
  class: "row date"
};
const _hoisted_8 = {
  class: "version"
};
const _hoisted_9 = {
  class: "row"
};
const _hoisted_10 = {
  class: "prompt",
  maxlength: "2000",
  rows: "18",
  readonly: ""
};
const _hoisted_11 = {
  key: 0,
  class: "music-player"
};
import { onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
import { httpGet } from "@/utils/http";
import { showMessageError } from "@/utils/dialog";
import { dateFormat } from "@/utils/libs";
import Clipboard from "clipboard";
import { ElMessage } from "element-plus";
import MusicPlayer from "@/components/MusicPlayer.vue";
export default {
  __name: 'Song',
  setup(__props) {
    const router = useRouter();
    const id = router.currentRoute.value.params.id;
    const song = ref({
      title: ""
    });
    const playList = ref([]);
    const playerRef = ref(null);
    httpGet("/suno/detail", {
      song_id: id
    }).then(res => {
      song.value = res.data;
      playList.value = [song.value];
      document.title = song.value?.title + " | By " + song.value?.user.nickname + " | Suno音乐";
    }).catch(e => {
      showMessageError("获取歌曲详情失败：" + e.message);
    });
    const clipboard = ref(null);
    onMounted(() => {
      clipboard.value = new Clipboard(".copy-link");
      clipboard.value.on("success", () => {
        ElMessage.success("复制歌曲链接成功！");
      });
      clipboard.value.on("error", () => {
        ElMessage.error("复制失败！");
      });
    });
    onUnmounted(() => {
      clipboard.value.destroy();
    });

    // 播放歌曲
    const play = () => {
      playerRef.value.play();
    };
    const winHeight = ref(window.innerHeight - 50);
    const getShareURL = item => {
      return `${location.protocol}//${location.host}/song/${item.id}`;
    };
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createElementBlock("div", {
        class: "page-song",
        style: _normalizeStyle({
          height: winHeight.value + 'px'
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("h2", _hoisted_2, _toDisplayString(song.value.title), 1), song.value.tags ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(song.value.tags), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, [_createVNode(_component_el_avatar, {
        size: 32,
        src: song.value.user?.avatar
      }, null, 8, ["src"])]), _createElementVNode("span", _hoisted_5, _toDisplayString(song.value.user?.nickname), 1), _createElementVNode("button", {
        class: "btn btn-icon",
        onClick: play
      }, [_cache[1] || (_cache[1] = _createElementVNode("i", {
        class: "iconfont icon-play"
      }, null, -1)), _createTextVNode(" " + _toDisplayString(song.value.play_times), 1)]), _createVNode(_component_el_tooltip, {
        content: "复制歌曲链接",
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("button", {
          class: "btn btn-icon copy-link",
          "data-clipboard-text": getShareURL(song.value)
        }, _cache[2] || (_cache[2] = [_createElementVNode("i", {
          class: "iconfont icon-share1"
        }, null, -1)]), 8, _hoisted_6)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(song.value.created_at)), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(song.value.raw_data?.major_model_version), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("textarea", _hoisted_10, _toDisplayString(song.value.prompt), 1)])]), playList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(MusicPlayer, {
        songs: playList.value,
        ref_key: "playerRef",
        ref: playerRef,
        onPlay: _cache[0] || (_cache[0] = $event => song.value.play_times += 1)
      }, null, 8, ["songs"])])) : _createCommentVNode("", true)], 4);
    };
  }
};